export default __webpack_public_path__ + "static/media/Iziel's Spite.4b2a7a74.jpg";